import DOMPurify from 'isomorphic-dompurify';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { logError } from '../../Analytics';
import Dialog, { DialogButton } from '../../Dialog';
import { fetchInAppMsg } from '../../InAppMessages/InAppMessages';
import { SessionStorageKeys } from '../../sessionStorage/keys';

export const HolidayMessage: React.FC = () => {
  const { pathname } = useRouter();
  const [htmlMessage, setHTMLMessage] = useState<{ html: string; open: boolean }>({ html: '', open: false });

  useEffect(() => {
    if (showModalOnRoutes.includes(pathname)) {
      fetchInAppMsg()
        .then((data) => {
          const shouldShow = shouldShowMessage(data);
          if (shouldShow) {
            const { alreadyShownTimes } = shouldShow;
            // At this point we are good to show message
            setHTMLMessage({ html: data.message, open: true });
            window.sessionStorage.setItem(SessionStorageKeys.HOLIDAY_MSG_SHOW_COUNT, String(alreadyShownTimes + 1));
          }
        })
        .catch((error) => {
          console.error(error);
          logError(`Error fetching in app message: ${error}`);
        });
    } else {
      setHTMLMessage((prev) => ({ ...prev, open: false }));
    }
  }, [pathname]);

  return (
    <Dialog
      open={htmlMessage.open}
      onClose={() => setHTMLMessage((prev) => ({ ...prev, open: false }))}
      buttons={
        <DialogButton id='dismissMsgModal' onClick={() => setHTMLMessage((prev) => ({ ...prev, open: false }))}>
          CLOSE
        </DialogButton>
      }
    >
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlMessage.html) }} />
    </Dialog>
  );
};

const showModalOnRoutes = ['/orders/new', '/orders/[orderId]/edit'];

const shouldShowMessage = (data: Awaited<ReturnType<typeof fetchInAppMsg>>) => {
  if (!data.message) {
    return false;
  }

  const now = Date.now();
  const showStartTime = data.dateRange[0].getTime();
  const showEndTime = data.dateRange[1].getTime();
  // If not in date range, don't show message
  if (!(showStartTime <= now && now <= showEndTime)) {
    return false;
  }

  const shownTimes = window.sessionStorage.getItem(SessionStorageKeys.HOLIDAY_MSG_SHOW_COUNT);
  const shownTimesInt = shownTimes == null ? 0 : parseInt(shownTimes);
  // If display counter exists and already shown more than the display counter, don't show message
  if (data.displayCounter != null && shownTimesInt >= data.displayCounter) {
    return false;
  }

  return { alreadyShownTimes: shownTimesInt };
};
